import React, { useState } from "react";
import {
  Form,
  Button,
  Table,
  Upload,
  Typography,
  Select,
  Input,
  Row,
  Col,
  InputNumber,
  Popconfirm,
  message,
  DatePicker,
  Divider,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch, useSelector } from "react-redux";
import { updateRolEnviromentAction } from "../../../actions/rolEnviromentActions";
//Styles
import "./CreateDesparasita.scss";

// Excel Render
import { ExcelRenderer } from "react-excel-renderer";

// componentes
import FRM from "../../../utils/FrmService";
import { reloadData } from "../../../utils/ReloadEnv";
import { showNotification } from "../../../utils/ShowNotification";
import curStyle from "../../../css/GlobalCmp.module.css";
import { colorSec, colorPrm, colorGrn } from "../../../constants";

export default function CreateDesparasita(props) {
  const {
    currentUser,
    closeModal,
    setIsLoading,
    myNumber,
    detalleCarga,
  } = props;
  const [loadingButton, setLoadingButton] = useState(false);
  const [idOrigen, setIdOrigen] = useState(detalleCarga.cmp_id);
  const [idAntipa, setIdAntipa] = useState(0);
  const [importe, setImporte] = useState("");
  const [nota, setNota] = useState("");
  const [fechaEntr, setFechaEntr] = useState(null);
  const [data, setData] = useState([]);
  const [dataDef, setDataDef] = useState([]);
  const [data2, setData2] = useState("");
  const [fileList, setFileList] = useState([]);

  const { Option } = Select;
  const [form] = Form.useForm();

  const antipaList = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.antiparasita
  );
  const fieldsList = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.origenes
  );

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const { Title } = Typography;
  const { TextArea } = Input;

  //Cambio de fecha
  function onChangeFecha(date, dateString) {
    setFechaEntr(dateString);
  }

  //Se actualiza el nombre
  const updateAntipa = async (value) => {
    setIdAntipa(value);
  };

  //Se actualiza el nombre
  const updateOrigen = async (value) => {
    setIdOrigen(value);
  };

  const onChangeImporte = (value) => {
    if (Number.parseFloat(value) >= 0) {
      setImporte(value);
    } else {
      message.error("VALOR INCORRECTO!", 1);
      return false;
    }
  };

  const onChangeNota = (e) => {
    const notaE = e.target.value;
    setNota(notaE.toUpperCase());
  };

  const propis = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      if (fileList.length > 0) {
        setFileList([file]);
      } else {
        setFileList([...fileList, file]);
      }
      UploadExcel(file);
      return false;
    },
    fileList,
  };

  const UploadExcel = async (file) => {
    //Obtengo la informacion del Input File
    let fileObj = file;

    //Render del Excel
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        // Elimino el encabezado del archivo
        var excel = resp.rows.filter(function (item, index, arr) {
          return item[0] !== "Fecha Lectura";
        });
        const bh_excel2 = [];
        excel.forEach(function (item, index, arr) {
          let cod = item[1].toString();
          let codigo = cod.split(" ");
          let dispositivo = codigo[0].substr(-8, 8);
          let key = index;
          let anm_codigo = dispositivo.trim();
          let anm_peso_neto = item[2];

          let exceldata = {
            key: key,
            anm_codigo: anm_codigo,
            anm_peso_neto: anm_peso_neto,
          };

          bh_excel2.push(exceldata);
        });
        setData(bh_excel2);
        setDataDef(bh_excel2);
      }
    });
  };

  //////////////////////////////////
  //Carga de los animales en campo
  const getDetalleCampo = async () => {
    if (idOrigen === 0) {
      showNotification(
        "topRight",
        2,
        "CARGAR ANIMALES",
        "DEBE REGISTRAR EL CAMPO DE ORIGEN"
      );
      return false;
    }
    setLoadingButton(true);
    let datos = await FRM.getCampoDet(currentUser, idOrigen);
    console.log(datos);
    if (datos.type && datos.type > 0) {
      setDataDef(datos.listado);
      setData2(datos.listado);
      setData([]);
    } else {
      showNotification("topRight", 2, "ERROR DE CONEXION", "Intente mas Tarde");
    }
    setLoadingButton(false);
  };
  /////////////////////////////////
  // ENVIO A WEBSERVICES
  const uploadDspWS = async () => {
    setLoadingButton(true);
    if (
      Number.parseInt(idOrigen) === 0 ||
      Number.parseInt(idAntipa) === 0 ||
      dataDef.length === 0 ||
      fechaEntr.length === 0
    ) {
      showNotification(
        "topRight",
        2,
        "APLICAR DESPARASITACION",
        "LOS DATOS ESTAN INCOMPLETOS PARA EL REGISTRO"
      );
    } else {
      let record = {
        usr_id: currentUser.id,
        cmp_id: detalleCarga.cmp_id,
        id_cmb: detalleCarga.id,
        cmb_id: detalleCarga.cmb_numero,
        atp_id: idAntipa,
        dsp_animales: dataDef.length,
        dsp_importe: importe,
        dsp_nota: nota,
        dsp_fecha: fechaEntr,
        record_def: dataDef,
      };
      var val_inventory = await FRM.sendDespara(currentUser, record);
      console.log(val_inventory);
      if (val_inventory.type && Number.parseInt(val_inventory.type) > 0) {
        updateEnviroment(val_inventory.datos.rol_entorno);
        showNotification("topRight", 4, "DESPARASITACION", "REGISTRO EXITOSO");
      } else {
        showNotification(
          "topRight",
          2,
          "DESPARASITACION",
          val_inventory.message
        );
      }
    }
    setData([]);
    setFileList([]);
    setLoadingButton(false);
    closeModal();
  };

  // Encabezados de la tabla de Excel Upload
  const header = [
    {
      title: "CARAVANA", //10%
      dataIndex: "anm_codigo",
      key: "anm_codigo",
    },
    {
      title: "PESO Kg",
      dataIndex: "anm_peso_neto",
      key: "anm_peso_neto",
      width: "20%",
      align: "right",
    },
  ];

  return (
    <div className="upload-panel">
      <Title level={4} style={{ color: "#6A3E98", textAlign: "center" }}>
        {"APLICACION DE ANTIPARASITARIO " + detalleCarga.cmp_nombre}
      </Title>
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="Fecha Proceso">
              <DatePicker onChange={onChangeFecha} style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col span={18}>
            <Form.Item label="Tipo de Medicamento">
              <Select
                showSearch
                showArrow
                style={{ width: "100%" }}
                defaultValue={
                  idAntipa === 0 ? "SELECCIONE MEDICAMENTO" : idAntipa
                }
                placeholder="MEDICAMENTO A APLICAR"
                onChange={updateAntipa}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {antipaList.map((antipa) => (
                  <Option key={antipa.id} value={antipa.id}>
                    {antipa.atp_nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col span={24}>
            <TextArea
              rows={2}
              value={nota}
              placeholder={"Observaciones"}
              onChange={onChangeNota}
              allowClear
            />
          </Col>
        </Row>
      </Form>
      <Divider style={{ marginTop: 15, paddingTop: 10, marginBottom: 5 }} />
      <div
        style={{
          display: "flex",
          alignContent: "left",
          marginBottom: 15,
          marginTop: 15,
        }}
      >
        <Button
          type="primary"
          shape="round"
          className={curStyle.btnBlueLight}
          loading={loadingButton}
          onClick={() => getDetalleCampo()}
        >
          <UploadOutlined /> ANIMALES EN CAMPO
        </Button>

        <Upload {...propis}>
          <Button
            type="primary"
            shape="round"
            className={curStyle.btnInfo}
            style={{
              marginLeft: 20,
            }}
          >
            <UploadOutlined /> ARCHIVO DEL BASTON
          </Button>
        </Upload>
      </div>
      <Table columns={header} dataSource={dataDef} bordered size="middle" />
      <Space>
        <Title
          level={4}
          style={{ color: colorSec, textAlign: "left", marginTop: 15 }}
        >
          {"Animales en CAMPO: " + myNumber(1, data2.length)}
        </Title>
        <Title
          level={4}
          style={{
            color: colorGrn,
            textAlign: "left",
            marginLeft: 30,
            marginTop: 15,
          }}
        >
          {"Registros BASTON: " + myNumber(1, data.length)}
        </Title>
      </Space>
      <div style={{ display: "flex", alignContent: "left", marginTop: 5 }}>
        <Popconfirm
          placement="top"
          title="CONFIRMAR EL MOVIMIENTO?"
          onConfirm={() => uploadDspWS()}
          okText="Si"
          cancelText="No"
        >
          <Button
            type="primary"
            shape="round"
            block
            style={{
              display: dataDef.length > 0 ? "block" : "none",
            }}
            loading={loadingButton}
          >
            <UploadOutlined /> PROCESAR LA APLICACION DEL MEDICAMENTO
          </Button>
        </Popconfirm>
      </div>
    </div>
  );
}
